import React, { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { dashboardService } from '../../services/dashboardService';

interface Props { 
  year?: string; 
  month?: string;
}

export const FinanceiroCards: React.FC<Props> = ({ year, month }) => {
  const { user, isGrupo, isEmpresa } = useAuth();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    const load = async () => {
      if (!user) return;
      setLoading(true);
      try {
        const params: any = {};
        if (year) params.year = Number(year);
        if (month) params.month = Number(month);
        
        let res;
        if (isGrupo && user.grupoId) {
          // Para grupo, usar o endpoint de grupo que consolida dados financeiros
          res = await dashboardService.grupoOverview(user.grupoId, params);
        } else if (isEmpresa && user.empresaId) {
          res = await dashboardService.financeiroOverview(user.empresaId, params);
        } else {
          throw new Error('Usuário não tem empresa ou grupo associado');
        }
        
        const payload = res?.data ?? res;
        setData(payload);
      } catch (err) {
        console.error('Erro ao carregar dashboard financeiro:', err);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    if (user && (isEmpresa || isGrupo)) load();
  }, [user, isGrupo, isEmpresa, month, year]);

  const fmt = (v: any) => {
    if (v === undefined || v === null) return '—';
    if (typeof v === 'number') return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    return String(v);
  };

  const fmtPercentage = (v: any) => {
    if (v === undefined || v === null) return '—';
    if (typeof v === 'number') return `${(v * 100).toFixed(1)}%`;
    return String(v);
  };

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      <div className="p-3 rounded shadow h-24 flex flex-col justify-between" style={{ backgroundColor: '#E8F5E9', color: '#1B5E20' }}>
        <h3 className="text-xs font-semibold">Receita Bruta</h3>
        <p className="text-sm font-bold">{loading ? 'Carregando...' : fmt(data?.receitaBruta)}</p>
      </div>
      
      <div className="p-3 rounded shadow h-24 flex flex-col justify-between" style={{ backgroundColor: '#E3F2FD', color: '#0D47A1' }}>
        <h3 className="text-xs font-semibold">Comissão Média</h3>
        <p className="text-sm font-bold">{loading ? 'Carregando...' : fmt(data?.comissaoMedia)}</p>
      </div>

      <div className="p-3 rounded shadow h-24 flex flex-col justify-between" style={{ backgroundColor: '#FFF3E0', color: '#E65100' }}>
        <h3 className="text-xs font-semibold">Prêmios a Receber</h3>
        <p className="text-sm font-bold">{loading ? 'Carregando...' : fmt(data?.premiosAReceber)}</p>
      </div>

      <div className="p-3 rounded shadow h-24 flex flex-col justify-between" style={{ backgroundColor: '#F3E5F5', color: '#6A1B9A' }}>
        <h3 className="text-xs font-semibold">Taxa Pagamento em Dia</h3>
        <p className="text-sm font-bold">{loading ? 'Carregando...' : fmtPercentage(data?.taxaPagamentoEmDia)}</p>
      </div>
    </div>
  );
};

export default FinanceiroCards;